module.exports = __webpack_public_path__ + "img/lawbg.2acf6479.png";